import { hashId } from '~kui/utils/hash';

/** How many blur backgrounds ship under /images/kui/learn/blur-bg (blur-1 … blur-N). */
const BLUR_BACKGROUND_COUNT = 8;

/**
 * Deterministic blur-background path for an id — the same id always resolves to the same
 * image, so an entity keeps a stable fallback banner wherever it appears (hero, cards).
 */
export const blurBackgroundImage = (id: string): string =>
  `/images/kui/learn/blur-bg/blur-${(hashId(id) % BLUR_BACKGROUND_COUNT) + 1}.webp`;
